import {
  LayersContainer,
  useModelId,
} from '@loomhq/createhq/dist/video-player/';
import {
  Align,
  Arrange,
  Button,
  Container,
  FormField,
  Icon,
  Spacer,
  SvgLock,
  Text,
  TextInput,
  u,
} from '@loomhq/lens';
import React, { useEffect, useState } from 'react';

import { useCheckPassword } from '../hooks';
import { usePasswordContext } from '../password/context';

const ERROR_MESSAGE = 'Password incorrect';

const PasswordLayer = (): React.ReactElement => {
  const videoId = useModelId();
  const pcontext = usePasswordContext();
  const [checkPassword] = useCheckPassword();
  const [hasError, setHasError] = useState(false);
  const [passwordValue, onPasswordChange] = useState('');

  const onSubmit = e => {
    e.preventDefault();
    checkPassword({
      variables: { videoId, password: passwordValue },
      onCompleted: data => {
        if (!data.isValid) {
          setHasError(true);

          return;
        }

        pcontext.setPassword(passwordValue);
      },
    });
  };

  useEffect(() => {
    setHasError(false);
  }, [passwordValue]);

  const submitIsDisabled = !passwordValue || hasError;

  return (
    <LayersContainer>
      <Container
        contentColor="body"
        backgroundColor="background"
        padding="medium"
        borderSide="all"
      >
        <Align>
          <Container width={`min(100%, ${u(40)})`}>
            <Spacer bottom="medium">
              <Arrange gap="small">
                <Icon icon={<SvgLock />} hasWidthOffset />
                <Text fontWeight="bold" size="large">
                  This video is password protected
                </Text>
              </Arrange>
            </Spacer>
            <form onSubmit={onSubmit}>
              <FormField
                direction="column"
                label="Password"
                labelFor="videoPassword"
                errorMessage={(hasError && ERROR_MESSAGE) || undefined}
              >
                <TextInput
                  type="password"
                  value={passwordValue}
                  hasError={hasError}
                  autoComplete="off"
                  onChange={e => onPasswordChange(e.target.value)}
                />
              </FormField>
              <Spacer top="medium">
                <Button
                  hasFullWidth
                  variant="primary"
                  isDisabled={submitIsDisabled}
                >
                  Enter
                </Button>
              </Spacer>
            </form>
          </Container>
        </Align>
      </Container>
    </LayersContainer>
  );
};

export default PasswordLayer;
